export default __webpack_public_path__ + "resources/icons/n432-6756.png";